import { capitalize, currencies } from 'lib';

export const STATUS_STYLES = {
    active: {
        bg: 'bg-emerald-50',
        text: 'text-emerald-700',
        ring: 'ring-1 ring-inset ring-emerald-600/20',
        dot: 'bg-emerald-500'
    },
    processing: {
        bg: 'bg-blue-50',
        text: 'text-blue-700',
        ring: 'ring-1 ring-inset ring-blue-600/20',
        dot: 'bg-blue-500'
    },
    initiated: {
        bg: 'bg-blue-50',
        text: 'text-blue-700',
        ring: 'ring-1 ring-inset ring-blue-600/20',
        dot: 'bg-blue-500'
    },
    retrying: {
        bg: 'bg-amber-50',
        text: 'text-amber-700',
        ring: 'ring-1 ring-inset ring-amber-600/20',
        dot: 'bg-amber-500'
    },
    suspended: {
        bg: 'bg-red-50',
        text: 'text-red-700',
        ring: 'ring-1 ring-inset ring-red-600/20',
        dot: 'bg-red-500'
    },
    cancelled: {
        bg: 'bg-red-50',
        text: 'text-red-700',
        ring: 'ring-1 ring-inset ring-red-600/20',
        dot: 'bg-red-500'
    },
    failed: {
        bg: 'bg-red-50',
        text: 'text-red-700',
        ring: 'ring-1 ring-inset ring-red-600/20',
        dot: 'bg-red-500'
    },
    refunded: {
        bg: 'bg-emerald-50',
        text: 'text-emerald-700',
        ring: 'ring-1 ring-inset ring-emerald-600/20',
        dot: 'bg-emerald-500'
    },
    pending: {
        bg: 'bg-amber-50',
        text: 'text-amber-700',
        ring: 'ring-1 ring-inset ring-amber-600/20',
        dot: 'bg-amber-400'
    }
};

export const EVENT_LABELS = {
  subscribed: 'Subscribed',
  renewed: 'Renewed',
  upgraded: 'Upgraded',
  downgraded: 'Downgraded',
  payment_succeeded: 'Payment succeeded',
  payment_failed: 'Payment failed',
  cancelled: 'Cancelled',
  renewal_failed: 'Renewal Failed',
  refund_requested: 'Refund requested',
  refund_approved: 'Refund approved',
  refund_rejected: 'Refund rejected'
};

export function getStatusStyle(status) {
  return (
    STATUS_STYLES[status] || {
      bg: 'bg-gray-50',
      text: 'text-gray-600',
      ring: 'ring-1 ring-inset ring-gray-500/10',
      dot: 'bg-gray-400'
    }
  );
}

export function getCurrencyObj(currencyCode) {
  return (
    currencies.find((c) => c.value.toLowerCase() === currencyCode?.toLowerCase()) ||
    currencies.find((c) => c.value.toUpperCase() === 'USD')
  );
}

export function formatAmount(amount, currencyCode) {
  const curr = getCurrencyObj(currencyCode);
  if (!curr) return '';
  const amt =
    currencyCode.toUpperCase() === 'JPY' ? amount.toLocaleString() : Number(amount).toFixed(2);
  return `${curr.symbol}${amt}`;
}

export function getFormattedAmountWithInterval(sub) {
  if (!sub) return '';
  const interval = sub.billingCycle === 'yearly' ? 'yr' : 'mo';
  return `${formatAmount(sub.amount, sub.currency)}/${interval}`;
}

const PAYMENT_TYPE_LABELS = {
  card: 'Card',
  credit_card: 'Card',
  konbini: 'Konbini',
  bank_transfer: 'Bank Transfer',
  paypay: 'PayPay',
  link: 'Link',
  us_bank_account: 'Bank Account',
  sepa_debit: 'SEPA Debit'
};

const KONBINI_STORE_LABELS = {
    'seven-eleven': 'Seven-Eleven',
    'lawson': 'Lawson',
    'family-mart': 'FamilyMart',
    'ministop': 'Ministop',
    'daily-yamazaki': 'Daily Yamazaki',
    'seicomart': 'Seicomart'
};

export function getPaymentMethodDisplay(sub) {
    if (!sub?.paymentMethod) return 'N/A';
    const { type, brand, last4, store } = sub.paymentMethod;

    if (brand && last4) return `${capitalize(brand)} ****${last4}`;
    if (last4) return `****${last4}`;
    if (type === 'konbini' && store) return `Konbini (${KONBINI_STORE_LABELS[store] || capitalize(store)})`;

  return PAYMENT_TYPE_LABELS[type] || capitalize(type || '') || 'N/A';
}

export function getStatusBadge(status) {
  const style = getStatusStyle(status);
  return `${style.bg} ${style.text} ${style.ring}`;
}

export const INVOICEABLE_EVENT_TYPES = ['subscribed', 'renewed', 'upgraded', 'downgraded'];
